import ReactDOM from 'react-dom';
import App from './App';
import index from './index.css';
import About from './components/about/About';


ReactDOM.render(<App />, document.querySelector("#root"));
